module.exports = __webpack_public_path__ + "static/media/btn.6a241d1b.svg";